import React from "react";
import ProspectForm from "../../LoanApplication/ProspectForm/prospectForm";

const Landing = ({ campaignDefaults }) => {
  return (
    <section className="container-fluid landing-wrapper">
      <div className="row landing-row">
        <header className="col-sm-10 offset-sm-1 col-lg-5">
          <h1 className="lighter-header text-white">
            Borrow up to <strong>$35,000</strong> with a <br/>
            <strong>
              Barclays
            </strong> Personal Loan
          </h1>
          <p className="blue-text text-lighten-4 sub-header">
            <i className="material-icons text-white" aria-hidden="true">check</i>Rates starting at { campaignDefaults.minApr }%
          </p>
          <p className="blue-text text-lighten-4 sub-header">
            <i className="material-icons text-white" aria-hidden="true">check</i>Loan terms of 36, 48 or 60 months
          </p>
          <p className="blue-text text-lighten-4 sub-header">
            <i className="material-icons text-white" aria-hidden="true">check</i>Absolutely NO fees
          </p>
        </header>
        <section className="prospect-step col-12 col-sm-10 offset-sm-1 col-lg-6 offset-lg-0 col-xl-4 offset-xl-1">
          <ProspectForm />
        </section>
      </div>
    </section>
  );
};

export default Landing;
